import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Filters = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 2fr) minmax(120px, 1fr) minmax(160px, 1fr) auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const StatusBadge = styled.span<{ $tone: "success" | "warning" | "danger" }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: ${({ $tone }) =>
    $tone === "success" ? colors.success : $tone === "warning" ? colors.amber : colors.danger};
`;

export const TariffCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TariffTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: ${colors.textPrimary};
`;

export const MutedLine = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

export const AccountsCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
